import { usePanelHistoryTop } from 'weblite-router'
import { useEffect } from 'react'
import * as R from 'ramda'
import { Divider } from '@mui/material'
import { UserListItemSkeleton } from '$common/user-list-item'
import { EmptyStateList } from '$common/empty-state-list'
import { withMultiSelectSearchableListPage } from '$common/multi-select-searchable-list-page'
import { showInviteConfirmModal } from '$comp/modals/confirmation-dialog'
import { closeInviteFromContacts } from '$logic/router'
import {
  useFetchInvitableUsers,
  useSearchedInviteUsers,
} from '$logic/invite/react-hook'
import { Invitee } from '$logic/invite/types'
import { t } from '$i18n'
import { sendEventToTwa } from '$logic/twaCommunication/twaCommunication.api'
import { TWA_EVENTS } from '$logic/twaCommunication'
import { InviteeChip } from '../invite-friends/components/invitee-chip'
import { InviteeListItem } from './components/invitee-list-item'

const ListItem = ({
  phone,
  firstname,
  lastname,
  invited,
  selected,
  onSelectedChange,
}: Invitee & {
  selected: boolean
  onSelectedChange: (isSelected: boolean) => unknown
}) => (
  <>
    <InviteeListItem
      firstname={firstname}
      lastname={lastname}
      phone={phone}
      isPassive={invited}
      hasDivider={false}
      selected={selected}
      onClick={() => onSelectedChange(!selected)}
    />
    <Divider variant="inset" />
  </>
)

export function InviteFromContacts({ limit }: { limit: number }) {
  const panelTop = usePanelHistoryTop('profile')
  useEffect(() => {
    const [topPage] = panelTop?.location?.split('/').slice(-1) ?? []
    if (topPage === 'INVITE_FROM_CONTACTS')
      sendEventToTwa(TWA_EVENTS.SYNC_CONTACT)
  }, [panelTop])

  const onComplete = async () => {
    // TODO: Implement me
    await closeInviteFromContacts()
  }

  const Page = withMultiSelectSearchableListPage<
    Invitee,
    null,
    { query: string; searchedItems: Invitee[] }
  >({
    appBarTitle: t('invite.inviteFromContacts'),
    selectionLimit: limit,
    SkeletonItem: UserListItemSkeleton,
    EmptyStateComponent: () => <EmptyStateList />,
    fetchHook: useFetchInvitableUsers,
    searchHook: useSearchedInviteUsers,
    ChipComponent: InviteeChip,
    selectionPrimaryKey: 'phone',
    onBack: closeInviteFromContacts,
    onConfirm: selectedItems =>
      showInviteConfirmModal(R.pluck('phone', selectedItems), onComplete),
  })

  return (
    <Page
      fetchHookParams={null}
      getSearchHookParams={(query, searchedItems) => ({ query, searchedItems })}
      ListItem={ListItem}
    />
  )
}
